import { render, staticRenderFns } from "./ParticipantsPage.vue?vue&type=template&id=55f65526&scoped=true&"
import script from "./ParticipantsPage.vue?vue&type=script&lang=js&"
export * from "./ParticipantsPage.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsPage.vue?vue&type=style&index=0&id=55f65526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f65526",
  null
  
)

export default component.exports